import React from "react";

import ApplicationProcedureEP from "./ApplicationProcedureEP";
import CareerOptionsEP from "./CareerOptionsEP";
import EligibilityEP from "./EligibilityEP";
import ObjectivesEP from "./ObjectivesEP";
import OutcomesEP from "./OutcomesEP";
import OverviewEP from "./OverviewEP";
import ProgramModulesEP from "./ProgramModulesEP";

const EP = () => {
  return (
    <div>
      <section id="overview" className="scroll-mt-40">
        <OverviewEP />
      </section>
      <section id="objectives" className="scroll-mt-40">
        <ObjectivesEP />
      </section>
      <section id="eligibility" className="scroll-mt-40">
        <EligibilityEP />
      </section>
      <section id="application-procedure" className="scroll-mt-40">
        <ApplicationProcedureEP />
      </section>
      <section id="career-options" className="scroll-mt-40">
        <CareerOptionsEP />
      
      </section>
      <section id="program-modules" className="scroll-mt-40">
        <ProgramModulesEP />
      
      </section>
      <section id="outcomes" className="scroll-mt-40">
        <OutcomesEP />
      </section>
    </div>
  );
};

export default EP;
